import { render, staticRenderFns } from "./Section6.vue?vue&type=template&id=60b1f0ff&"
import script from "./Section6.vue?vue&type=script&lang=js&"
export * from "./Section6.vue?vue&type=script&lang=js&"
import style0 from "./Section6.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports